import React, { useContext, useState } from "react";
import {
	Table,
	TableHead,
	TableBody,
	TableRow,
	TableCell,
	Paper,
	TableContainer,
	TableFooter,
	LinearProgress,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import LockResetIcon from "@mui/icons-material/LockReset";
import { ContextRegisterCollaborator } from "../context";
import { handleMessageError, handleMessageWarning } from "../../../toast";
import "./style.css";
import CustomPagination from "../../../paginate";

function TableCollaborator(props) {
	const itemsPerPage = 15; // Quantidade de itens por página

	const {
		collaboratorData,
		openModalRegisterCollaborator,
		page,
		setPage,
		totalPage,
		currentPage,
		fetchCollaboratorPage,
		loading,
		openModalRecoveryCollaborator,
	} = useContext(ContextRegisterCollaborator);
	// const [page, setPage] = useState(1);

	// const handleChangePage = (event, newPage) => {
	// 	setPage(newPage);
	// };
	const handleChangePage = (event, newPage) => {
		//se a pagina não foi carregada faz a pesquisa no banco
		if (newPage > currentPage.current) {
			fetchCollaboratorPage();
		}

		if (totalPage > 0) {
			if (newPage > totalPage) return;
		}

		setPage(newPage);
	};

	const startIndex = (page - 1) * itemsPerPage;
	const endIndex = startIndex + itemsPerPage;
	const slicedData = collaboratorData.slice(startIndex, endIndex);

	return (
		<>
			{/* <Paper> */}
			<TableContainer component={Paper}>
				<Table>
					<TableHead className="color-table">
						<TableRow>
							<TableCell style={{ width: "200", whiteSpace: "nowrap" }}>
								<span className="text-color-table">Nome</span>
							</TableCell>
							<TableCell style={{ width: "200px" }}>
								<span className="text-color-table">Endereço</span>
							</TableCell>
							<TableCell style={{ width: "150px" }}>
								<span className="text-color-table">Bairro</span>
							</TableCell>
							<TableCell style={{ width: "50px" }}>
								<span className="text-color-table">Telefone</span>
							</TableCell>

							<TableCell style={{ width: "50px" }}>
								<span className="text-color-table">Ativo</span>
							</TableCell>

							<TableCell
								style={{
									width: "100px",
									textAlign: "center",
									verticalAlign: "middle",
									position: "sticky",
									right: 0,
									backgroundColor: "var(--texto-secondary)",
									zIndex: 10
								}}
							>
								<span className="text-color-table">Ações</span>
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{slicedData.map((item, key) => (
							<TableRow key={key} className="zebra-row">
								<TableCell style={{ whiteSpace: "nowrap" }}>{item.nome}</TableCell>
								<TableCell style={{ whiteSpace: "nowrap" }}>{item.rua}</TableCell>
								<TableCell style={{ whiteSpace: "nowrap" }}>{item.bairro}</TableCell>
								<TableCell style={{ whiteSpace: "nowrap" }}>{item.telefone_1}</TableCell>
								<TableCell style={{}}>{item.ativo}</TableCell>
								<TableCell
									style={{
										textAlign: "center",
										verticalAlign: "middle",
										position: "sticky",
										right: 0,
										backgroundColor: "#fff",
										zIndex: 2,
										boxShadow: "-2px 0 5px rgba(0,0,0,0.05)"
									}}
								>
									<div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
										<button
											className="btn-action-premium btn-recovery-password"
											title="Recuperar Senha"
											onClick={(e) => {
												if (item.email) {
													openModalRecoveryCollaborator(item);
												} else {
													handleMessageWarning(
														"Este colaborador não possui e-mail de acesso cadastrado.",
													);
												}
											}}
										>
											<LockResetIcon sx={{ fontSize: 18 }} />
										</button>
										<button
											className="btn-action-premium btn-edit-collaborator"
											title="Editar Colaborador"
											onClick={(e) => openModalRegisterCollaborator(item)}
										>
											<EditIcon sx={{ fontSize: 18 }} />
										</button>
									</div>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
					{loading ? (
						<TableFooter>
							<TableRow>
								<TableCell colSpan={document.querySelectorAll("thead th").length}>
									<LinearProgress variant="indeterminate" />
								</TableCell>
							</TableRow>
						</TableFooter>
					) : (
						collaboratorData.length === 0 && (
							<TableBody>
								<TableRow>
									<TableCell
										colSpan={document.querySelectorAll("thead th").length}
										className="italic text-gray-400"
									>
										Nenhum registro encontrado.
									</TableCell>
								</TableRow>
							</TableBody>
						)
					)}
				</Table>

				{collaboratorData?.length > 0 && (
					<CustomPagination
						count={Math.ceil(collaboratorData.length / itemsPerPage)}
						page={page}
						onChangePage={handleChangePage}
						totalRecord={collaboratorData.length}
						totalPage={totalPage}
						itemsPerPage={itemsPerPage}
					/>
				)}
				{/* <Stack sx={{ justifyContent: "center", alignItems: "center", mt: 2 }}>
							<Pagination count={Math.ceil(collaboratorData.length / itemsPerPage)} page={page} onChange={handleChangePage} />
						</Stack> */}
				{/* </Paper> */}
			</TableContainer>
		</>
	);
}

export default TableCollaborator;
